



































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table, TableRowsSelect } from "@/utils/decorator";
import StandardFlag from "@/components/scope/standard-flag.vue";

const setting = namespace("setting");

@Component({
  components: { TableEnableFlag, StandardFlag }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: window._I18N.t("setting.choose-payment-method"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class TestingItemList extends Vue {
  @setting.Action getPatternPaymentList;
  @setting.Action savePayMethod;
  @setting.Action updateStatusList;
  @setting.Action updateSortList;
  allRightSelect = false;
  switchState = true;
  showCreatedPay = false;
  searchForm: any = {
    payMethodName: "",
    payMethodCode: ""
  };
  searchFormRules: any = {
    payMethodName: [{ required: true, message: window._I18N.t("setting.name-cannot-empty"), trigger: "blur" }]
  };
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  cardTemplateList: any[] = [];
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status) {
    return this.updateStatusList({
      status: status,
      payMethodCodeArray: this.mix_selectedRows.map(item => item.payMethodCode)
    })
      .then(data => {
        // this.$message.success(
        //   status === "1"
        //     ? (this.$t("setting.enable-successful") as string)
        //     : (this.$t("setting.disable-success") as string)
        // );
        this.mix_selectedRows = [];
        this.loadListData();
      })
      .catch(e => {
        if (e.code === "speedbiz.system.pay-method-least-one-valid") {
          this.$message.error(window._I18N.t("setting.valid-method-payment"));
        }
      });
  }
  created() {
    this.init();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPatternPaymentList({
      payMethodName: "",
      status: ""
    }).then(data => {
      this.cardTemplateList = data.data;
      return data;
    });
  }
  async init() {
    this.loadListData();
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.newPayMode();
      } else {
        console.log("error submit!!");
      }
    });
  }
  newPayMode() {
    const parameters = {
      payMethodName: this.searchForm.payMethodName,
      payMethodCode: ""
    };
    this.savePayMethod(parameters).then(data => {
      this.loadListData();
      this.$message.success(window._I18N.t("finance.new-payment-method-successful!"));
      this.showCreatedPay = false;
      const refPay = this.$refs.searchForm as any;
      refPay.resetFields();
    });
  }
  handleEdit(row) {
    this.$router.push(`/marketing/card-template-edit/${row.cardTemplateCode}`);
  }
  handleView(row) {
    this.$router.push(`/marketing/card-template-view/${row.cardTemplateCode}`);
  }
  upOne(scope) {
    let index = this.cardTemplateList.findIndex(item => item.payMethodCode === scope.row.payMethodCode);
    let tmp;
    tmp = this.cardTemplateList[index];
    this.cardTemplateList[index] = this.cardTemplateList[index - 1];
    this.cardTemplateList[index - 1] = tmp;
    this.sortArrList(this.cardTemplateList);
  }
  upTop(scope) {
    let index = this.cardTemplateList.findIndex(item => item.payMethodCode === scope.row.payMethodCode);
    let tmp;
    tmp = this.cardTemplateList[index];
    let arr = this.cardTemplateList;
    arr.splice(index, 1);
    arr.unshift(tmp);

    this.sortArrList(arr);
  }
  downOne(scope) {
    let index = this.cardTemplateList.findIndex(item => item.payMethodCode === scope.row.payMethodCode);
    let tmp;
    tmp = this.cardTemplateList[index];
    this.cardTemplateList[index] = this.cardTemplateList[index + 1];
    this.cardTemplateList[index + 1] = tmp;
    this.sortArrList(this.cardTemplateList);
  }
  downBottom(scope) {
    let index = this.cardTemplateList.findIndex(item => item.payMethodCode === scope.row.payMethodCode);
    let tmp;
    tmp = this.cardTemplateList[index];
    let arr = this.cardTemplateList;
    arr.splice(index, 1);
    arr.push(tmp);
    this.sortArrList(arr);
  }
  sortArrList(arr) {
    this.updateSortList({
      payMethodCodeArray: arr.map(item => {
        return item.payMethodCode;
      })
    }).then(data => {
      this.$message.success(window._I18N.t("setting.operate-successfully"));
      this.loadListData();
    });
  }
  switchChangeSure(row) {
    //  先改本地数据，然后请求更改数据库数据
    this.switchState = this.switchState ? false : true;
    let status = row.status === "1" ? "0" : "1";
    this.mix_selectedRows.push(row);
    this.confirmUpdateStatus(status);
  }
  switchChange(switchState) {
    this.switchState = !switchState;
    return;
  }
  allSelect(all) {
    if (all.length === this.cardTemplateList.length) {
      this.allRightSelect = true;
    } else {
      this.allRightSelect = false;
    }
  }
  isAllSelect(all, row) {
    //   根据数据长度every判断是否为全选
    if (all.length === this.cardTemplateList.length) {
      this.allRightSelect = true;
    } else {
      this.allRightSelect = false;
    }
  }
  //----------------
}
